import pinkHortensia from "../img/cele-mai-vindute/Pink-Hortensia.webp";
import pinkHarmony from "../img/cele-mai-vindute/Pink-Harmony.webp";
import silvaPinkDeluxe from "../img/cele-mai-vindute/Silva-Pink-Deluxe.webp";
import serenity from "../img/cele-mai-vindute/Serenity.webp";
import fleur from "../img/cele-mai-vindute/fleur.webp";
import sofia from "../img/cele-mai-vindute/sofia.webp";
import radiantRomance from "../img/cele-mai-vindute/radiant-romance.webp";
import noblespring from "../img/new/022noble.webp";
import mixeddreams from "../img/new/023mixeddreams.webp";
import secretmix from "../img/new/024secretmix.webp";
import ethernaldream from "../img/new/021eternaldream.webp";
import springwaltz from "../img/new/014springwaltz.webp";
import royalgarden from "../img/new/017royalgarden.webp";
import pinkdelight from "../img/new/016pinkdelight.webp";
import silkspring from "../img/new/018silkspring.webp";
// import blushingluxe from "../img/new/033blushing_luxe.webp";
// import blueskies from "../img/new/025blue_skies.webp";
import blushharmony from "../img/new/028blush_harmony.webp";
import hydrangeamelody from "../img/new/015hidrangeamelody.webp";
import splendor from "../img/buchete-premium/6splendor.webp";
import velvetParadise from "../img/buchete-premium/20velvet-paradise.webp";
import roseCharm from "../img/buchete-premium/29rose-charm.webp";
import tulipReverie from "../img/buchete-de-primavara/8tulip-reverie.webp";
import snowdrop from "../img/buchete/26snowdrop.webp";
import blushCascade from "../img/feb2026/blush_cascade.webp";
import blushTheory from "../img/feb2026/blush_theory.webp";
import moonlitRoses from "../img/feb2026/moonliit_roses.webp";
import petalMuse from "../img/feb2026/petal_muse.webp";
import pinkAura from "../img/feb2026/pink_aura.webp";
import pureWhite from "../img/feb2026/pure_white.webp";
import signaturePink from "../img/feb2026/signature_pink.webp";
import wildHoney from "../img/feb2026/wild_honey.webp";
import royalMix from "../img/feb2026/01Royal_Mix.webp";
import blancAndRose from "../img/feb2026/02_Blanc_and_Rose.webp";
import gardenSmile from "../img/feb2026/04Garden_Smile.webp";
import jardinBlush from "../img/feb2026/05Jardin_blush.webp";
import tender from "../img/feb2026/06Tender.webp";
import signatureRoses from "../img/feb2026/07Signature_Roses.webp";
import FreshPink from "../img/feb2026/08Fresh_pink.webp";
import aspenRose from "../img/feb2026/10aspen_rose.webp";
import blushingTulle from "../img/feb2026/11blushing_tulle.webp";
import cloudyWhite from "../img/feb2026/12cloudy_white.webp";
import lavenderDream from "../img/feb2026/13Lavender_dream.webp";
import oliveBlossom from "../img/feb2026/14olive_blossom.webp";
import petalMist from "../img/feb2026/15Petal_mist.webp";
import royalOrchid from "../img/feb2026/16royal_orchid.webp";
import sandyRose from "../img/feb2026/17Sandy_Rose.webp";
import sweetMint from "../img/feb2026/18sweet_mint.webp";
import velvetMauve from "../img/feb2026/19velvet_mauve.webp";
import suspiro from "../img/may2026/01_suspiro.webp";
import dreamCloud from "../img/may2026/02_dream_cloud.webp";
import springWhisper from "../img/may2026/03_spring_whisper.webp";
import blueAvalanche from "../img/may2026/04_blue_avalanche.webp";
import sofiaInBloom from "../img/may2026/05_sofia_in_bloom.webp";
import coralPeony from "../img/may2026/06_coral_peony.webp";
import coralInSpring from "../img/may2026/07_coral_in_spring.webp";
import coralSilvaMix from "../img/may2026/08_coral_silva_mix.webp";
import springInGreen from "../img/may2026/09_spring_in_green.webp";
import anturiumLove from "../img/may2026/10_anturium_love.webp";
import tenderMood from "../img/may2026/11_tender_mood.webp";
import beSweet from "../img/may2026/12_be_sweet.webp";
import calmAndLovely from "../img/may2026/13_calm_and_lovely.webp";
import justForYou from "../img/may2026/14_just_for_you.webp";
import pureFeeling from "../img/may2026/15_pure_feeling.webp";
import peonyBloom from "../img/may2026/16_peony_bloom.webp";
import floralStory from "../img/may2026/17_floral_story.webp";
import velvetPeony from "../img/may2026/18_velvet_peony.webp";
import tenderCharm from "../img/may2026/19_tender_charm.webp";
import dreamer from "../img/may2026/20_dreamer.webp";
import sweetMorning from "../img/may2026/21_sweet_morning.webp";
import gentleDream from "../img/may2026/22_gentle_dream.webp";
import nudeBouquet from "../img/may2026/23_nude_bouquet.webp";
import softStory from "../img/may2026/24_soft_story.webp";

import maisonDeFleurs from "../img/aug2026/1_MaisonDeFleurs.webp";
import loveCrush from "../img/aug2026/2_LoveCrush.webp";
import imperialBlue from "../img/aug2026/3_ImperialBlue.webp";
import loveSpell from "../img/aug2026/4_LoveSpell.webp";
import grandeBloom from "../img/aug2026/5_GrandeBloom.webp";
import blueVanilla from "../img/aug2026/6_BlueVanilla.webp";
import seduction from "../img/aug2026/7_Seduction.webp";
import summerRomance from "../img/aug2026/8_SummerRomance.webp";
import silkVanilla from "../img/aug2026/9_SilkVanilla.webp";

// 1-49
const celeMaiVindute = [
  {
    id: 1110,
    name: "Maison De Fleurs",
    price: "2300 lei",
    description:
      "Buchet elegant format din hortensii, trandafiri crenguța, eustome, crizantema, antirinium și eucalip.",
    images: [maisonDeFleurs],
  },
  {
    id: 1111,
    name: "Love Crush",
    price: "1500 lei",
    description:
      "Buchet elegant format din trandafiri Silva Pink, anthurium,eustome, dianthus, antirinium, trandafiri albi cu un cap, trandafiri roz tip crenguța și eucalipt.",
    images: [loveCrush],
  },
  {
    id: 1112,
    name: "Imperial Blue",
    price: "2200 lei",
    description:
      "Buchet elegant format din hortensii, trandafiri de tip crenguța Sofia, eustome și eucalip.",
    images: [imperialBlue],
  },
  {
    id: 1113,
    name: "Love Spell",
    price: "1450 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri roz de tip crenguța, antirinium, anturium, trandafiri de tip bujor Silva Pink și eucalipt.",
    images: [loveSpell],
  },
  {
    id: 1114,
    name: "Grandè Bloom",
    price: "3500 lei",
    description:
      "Buchet elegant format din hortensii, trandafiri Bujor și eucalipt.",
    images: [grandeBloom],
  },
  {
    id: 1115,
    name: "Blue Vanilla",
    price: "750 lei",
    description: "Buchet format din hortensie, eustome și Gherbera roz.",
    images: [blueVanilla],
  },
  {
    id: 1116,
    name: "Seduction",
    price: "850 lei",
    description:
      "Buchet format din hortensie, trandafiri tip crenguța Sofia și eustome albe.",
    images: [seduction],
  },
  {
    id: 1117,
    name: "Summer Romance",
    price: "1900 lei",
    description:
      "Buchet în culori pastelate format din hortensii, eustome și eucalip.",
    images: [summerRomance],
  },
  {
    id: 1118,
    name: "Silk Vanilla",
    price: "1100 lei",
    description: "Buchet format dintr-un mix de eustome alb și roz.",
    images: [silkVanilla],
  },

  {
    id: 1096,
    name: "Floral Story",
    price: "800 lei",
    description:
      "Buchet format din hortensii, bujori, eustoma, crizantema și eucalipt.",
    images: [floralStory],
  },
  {
    id: 1103,
    name: "Soft Story",
    price: "800 lei",
    description:
      "Buchet format din hortensie, trandafiri crenguta, eustoma și eucalipt.",
    images: [softStory],
  },
  {
    id: 1090,
    name: "Tender Mood",
    price: "1400 lei",
    description:
      "Buchet format din crengi de trandafiri de tip bujor Silva Pink. ",
    images: [tenderMood],
  },
  {
    id: 1102,
    name: "Nude Bouquet",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri cu un cap, trandafiri Silva Pink, eustoma, crizantema și eucalipt.",
    images: [nudeBouquet],
  },
  {
    id: 1100,
    name: "Sweet Morning",
    price: "550 lei",
    description: "Buchet format din bujori, eustome, matiola si crizantema.",
    images: [sweetMorning],
  },
  {
    id: 1080,
    name: "Suspiro",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, Matiola, trandafiri crenguța, eustome și eucalipt. ",
    images: [suspiro],
  },
  {
    id: 1081,
    name: "Dream Cloud",
    price: "1700 lei",
    description:
      "Buchet format din trandafiri de tip Bujor Silva Pink, gipsofila și eucalipt. ",
    images: [dreamCloud],
  },
  {
    id: 1082,
    name: "Spring Whisper",
    price: "2300 lei",
    description:
      "Buchet format din hortensie, vibrunum, trandafiri de tip Bujor, eustoma, crizantema și eucalipt. ",
    images: [springWhisper],
  },
  {
    id: 1083,
    name: "Blue Avalanche",
    price: "900 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome, dianthus și eucalipt. ",
    images: [blueAvalanche],
  },
  {
    id: 1084,
    name: "Sofia In Bloom",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri crenguța Sofia, eustome și eucalipt. ",
    images: [sofiaInBloom],
  },
  {
    id: 1088,
    name: "Spring In Green",
    price: "1600 lei",
    description:
      "Buchet format din hortensie, anturium, trandafiri de tip bujor, matiola, eustome, vibrunum și eucalipt. ",
    images: [springInGreen],
  },
  {
    id: 1089,
    name: "Anturium Love",
    price: "2500 lei",
    description:
      "Buchet format din hortensii, anturium, trandafiri de tip bujor Silva Pink, vibrunum, matiola, eustome și eucalipt. ",
    images: [anturiumLove],
  },

  {
    id: 1091,
    name: "Be Sweet",
    price: "3000 lei",
    description: "Buchet format din 35 trandafiri roz de lungime 80cm. ",
    images: [beSweet],
  },

  {
    id: 1092,
    name: "Calm & Lovely",
    price: "1900 lei",
    description:
      "Buchet format din hortensii, trandafiri de tip bujor, crizantema, eustome și eucalipt. ",
    images: [calmAndLovely],
  },

  {
    id: 1093,
    name: "Just For You",
    price: "2600 lei",
    description: "Buchet format din hortensii, trandafiri și eucalipt.",
    images: [justForYou],
  },

  {
    id: 1094,
    name: "Pure Feeling",
    price: "1750 lei",
    description:
      "Buchet format din hortensii, trandafiri Sofia, vibrunum, eustome și eucalipt.",
    images: [pureFeeling],
  },

  {
    id: 589,
    name: "Lavender Dream",
    price: "900 lei",
    description:
      "Buchet format din hortensie, trandafir, eustome si eucalipt. ",
    images: [lavenderDream],
  },

  {
    id: 591,
    name: "Olive Blossom",
    price: "750 lei",
    description:
      "Buchet format din hortensie, crizanteme, frezie si eucalipt. ",
    images: [oliveBlossom],
  },
  {
    id: 592,
    name: "Sandy Rose",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, trandafir cu un cap,orhidee, crizanteme, eustoma, azothamus si eucalipt. ",
    images: [sandyRose],
  },
  {
    id: 593,
    name: "Cloudy White",
    price: "650 lei",
    description:
      "Buchet format din crizanteme, eustome, trandafir de tip bujor. ",
    images: [cloudyWhite],
  },
  {
    id: 594,
    name: "Velvet Mauve",
    price: "1050 lei",
    description:
      "Buchet format din hortensie, eustome, trandafiri si eucalipt. ",
    images: [velvetMauve],
  },
  {
    id: 595,
    name: "Petal Mist",
    price: "750 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri crenguta, trandafir cu un cap si eucalipt. ",
    images: [petalMist],
  },
  {
    id: 596,
    name: "Sweet Mint",
    price: "700 lei",
    description:
      "Buchet format din crizanteme, eustome, trandafiri de tip bujor, eustome si eucalipt. ",
    images: [sweetMint],
  },
  {
    id: 1516,
    name: "Blanc and Rose",
    price: "1950 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip Bujor, azotamus, oxypetalum si eucalipt. ",
    images: [blancAndRose],
  },
  {
    id: 1519,
    name: "Jardin Blush",
    price: "880 lei",
    description:
      "Buchet format din trandafiri de tip bujor, azotamus si eucalipt. ",
    images: [jardinBlush],
  },
  {
    id: 1520,
    name: "Tender",
    price: "2100 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip Bujor, azotamus, gypsofila si eucalipt.",
    images: [tender],
  },
  {
    id: 1521,
    name: "Signature Roses",
    price: "2350 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri crenguta si eucalipt. ",
    images: [signatureRoses],
  },
  {
    id: 1522,
    name: "Fresh Pink",
    price: "1100 lei",
    description:
      "Buchet format din trandafiri de tip bujor si lalele olandeze de tip bujor si matricaria. ",
    images: [FreshPink],
  },
  {
    id: 1502,
    name: "Blush Cascade",
    price: "2700 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor si eustome. ",
    images: [blushCascade],
  },
  {
    id: 1503,
    name: "Blush Theory",
    price: "5300 lei",
    description:
      "Cos elegant format din trandafiri de tip bujor, lalele, frezie, ranuculus si eucalipt. ",
    images: [blushTheory],
  },

  {
    id: 1506,
    name: "Moonlit Roses",
    price: "1100 lei",
    description:
      "Buchet format din trandafir de tip bujor, eustome si eucalipt. ",
    images: [moonlitRoses],
  },
  {
    id: 1507,
    name: "Petal Muse",
    price: "3200 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, crizanteme, ranuculus si frezie. ",
    images: [petalMuse],
  },
  {
    id: 1508,
    name: "Pink Aura",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [pinkAura],
  },
  {
    id: 1509,
    name: "Pure White",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, crizanteme, ranuculus, trandafir de tip bujor, gipsofila si eucalipt. ",
    images: [pureWhite],
  },
  {
    id: 1511,
    name: "Signature Pink",
    price: "1250 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [signaturePink],
  },
  {
    id: 1514,
    name: "Wild honey",
    price: "850 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, dhiantus, trandafiri Lidia si eucalipt. ",
    images: [wildHoney],
  },

  {
    id: 12,
    name: "Silva Pink Deluxe",
    price: "4000 lei",
    description:
      "Buchet impresionant format din trandafiri de tip Bujor și eucalipt.",
    images: [silvaPinkDeluxe],
  },
  {
    id: 303,
    name: "Splendor",
    price: "3400 lei",
    description:
      "Buchet rafinat format din hortensii, trandafiri Silva Pink si eucalipt.",
    images: [splendor],
  },
  {
    id: 304,
    name: "Hydrangea Melody",
    price: "3000 lei",
    description:
      "Buchet spectaculos format din 7 hortensii si mix de trandafiri. ",
    images: [hydrangeamelody],
  },
  {
    id: 3,
    name: "Pink Hortensia",
    price: "2500 lei",
    description:
      "Buchet format din hortensii, trandafiri de tip bujor și eustome.",
    images: [pinkHortensia],
  },

  {
    id: 317,
    name: "Velvet Paradise",
    price: "2750 lei",
    description:
      "Buchet elegant format din hortensii, trandafiri Avalanche, trandafiri de tip bujor, eustome roz si eucalipt.",
    images: [velvetParadise],
  },
  {
    id: 15,
    name: "Radiant Romance",
    price: "3600 lei",
    description: "Buchet minunat din hortensii și trandafiri de tip Bujor.",
    images: [radiantRomance],
  },
  {
    id: 324,
    name: "Rose Charm",
    price: "1900 lei",
    description:
      "Buchet rafinat format din hortensii, trandafiri Silva Pink si eucalipt.",
    images: [roseCharm],
  },
  {
    id: 18,
    name: "Fleur",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, orhidei trandafiri, eucalipt,crizantema si gipsofila.",
    images: [fleur],
  },
  {
    id: 16,
    name: "Sofia",
    price: "1800 lei",
    description:
      "Buchet superb din trandafiri de soi Sofia , eustome albe și eucalipt.",
    images: [sofia],
  },
  {
    id: 11,
    name: "Royal Garden",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, trandafiri rosii si eucalipt.",
    images: [royalgarden],
  },

  // {
  //   id: 20,
  //   name: "Blue Skies",
  //   price: "900 lei",
  //   description:
  //     "Buchet format din hortensie, crizanteme, trandafiri de tip bujor.",
  //   images: [blueskies],
  // },
  // {
  //   id: 19,
  //   name: "Blushing Luxe",
  //   price: "1250 lei",
  //   description: "Buchet format din hortensie, eustome, trandafiri, bujori.",
  //   images: [blushingluxe],
  // },
  {
    id: 1,
    name: "Serenity",
    price: "1050 lei",
    description: "Buchet superb din trandafiri și eustome.",
    images: [serenity],
  },
  {
    id: 4,
    name: "Ethernal Dream",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, oxypetalum si eucalipt.",
    images: [ethernaldream],
    // checkAvailability: true,
  },

  // {
  //   id: 7,
  //   name: "Peony Light",
  //   price: "1800 lei",
  //   description:
  //     "Buchet format din hortensie, bujori, trandafiri, eustome, crizanteme și eucalipt. ",
  //   images: [peonyLight],
  // },
  {
    id: 8,
    name: "Noble Spring",
    price: "950 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri Avalanche, eustome si eucalipt. ",
    images: [noblespring],
  },
  {
    id: 9,
    name: "Pink Delight",
    price: "1600 lei",
    description:
      "Buchet format din trandafiri de tip bujor si verdeata decorativa.",
    images: [pinkdelight],
  },
  {
    id: 10,
    name: "Spring Waltz",
    price: "800 lei",
    description:
      "Buchet format din hortensie, gipsofila, trandafiri de tip bujor si eucalipt.",
    images: [springwaltz],
  },
  {
    id: 21,
    name: "Blush Harmony",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, trandafiri Silva Pink, eustome si eucalipt. ",
    images: [blushharmony],
  },

  // {
  //   id: 14,
  //   name: "Petals",
  //   price: "1400 lei",
  //   description:
  //     "Buchet din format din hortensie, trandafir, Matiola, crizantema, Eustoma și hypericum.",
  //   images: [petals],
  // },

  // {
  //   id: 17,
  //   name: "Blossom Flora",
  //   price: "3750 lei",
  //   description:
  //     "Buchet cu aspect luxuriant format din hortensii, trandafiri de tip Bujor, trandafiri de soi avalanche, orhidei și  crizantema.",
  //   images: [blossomFlora],
  // },
  {
    id: 2,
    name: "Mixed Dreams",
    price: "750 lei",
    description:
      "Buchet format din trandafiri de tip bujor, eustome, crizanteme, trandafiri de tip Avalanche și eucalipt.",
    images: [mixeddreams],
  },
  {
    id: 454,
    name: "Snowdrop",
    price: "800 lei",
    description: "Buchet elegant format din crizanteme, trandafiri si eustome.",
    images: [snowdrop],
  },
  {
    id: 13,
    name: "Silk Spring",
    price: "550 lei",
    description:
      "Buchet format din trandafiri Sofia, dianthus, trandafiri crenguta si eucalipt.",
    images: [silkspring],
  },
  {
    id: 6,
    name: "Secret Mix",
    price: "750 lei",
    description:
      "Buchet format din trandafiri de tip bujor, crizanteme, trandafiri Avalanche eucalipt și eustome.",
    images: [secretmix],
  },
];
export default celeMaiVindute;
